import { render, staticRenderFns } from "./online-list.vue?vue&type=template&id=006d5c6d&scoped=true&"
import script from "./online-list.vue?vue&type=script&lang=js&"
export * from "./online-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d5c6d",
  null
  
)

export default component.exports